import { IconButton } from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

import DeleteModal from '@Components/Modal/DeleteModal';
import { useDisclosure } from '@hooks/useDisclosure';
import { useNatureOfBusinessForm } from '@Router/NatureOfBusiness/Containers/NatureOfBusinessFormProvider';
import { IIncomeStructureFormValues } from '@Router/NatureOfBusiness/Containers/NatureOfBusinessFormProvider/types';
import {
  EXPORT_INCOME_TYPE_ID,
  OTHER_INCOME_STRUCTURE_ID,
  INCOME_SUBGROUP_CATEGORY,
} from 'src/Enum/IncomeStructure';
import { calcNetIncomeItem, sumExtendedValues, yearFields } from '../../utils';

type ExportIncomeDeleteButtonProps = {
  keyItem: string;
};

const ExportIncomeDeleteButton = ({
  keyItem,
}: ExportIncomeDeleteButtonProps) => {
  const [opened, { open, close }] = useDisclosure();
  const { getValues, unregister, watch, setValue } = useNatureOfBusinessForm();

  const completedSection = watch(
    'incomeStructure.completedSection'
  ) as IIncomeStructureFormValues['completedSection'];
  const { isCompletedTh = false, isCompletedEn = false } =
    completedSection ?? {};

  const exportIncomeItems = getValues(
    'incomeStructure.exportIncomeItems'
  ) as IIncomeStructureFormValues['exportIncomeItems'];
  const countryNameTh = exportIncomeItems[keyItem].incomeCategory?.nameTh ?? '';

  const handleDelete = () => {
    unregister(`incomeStructure.exportIncomeItems.${keyItem}`);
    unregister(`incomeStructure.exportIncomePercentages.${keyItem}`);
    unregister(
      `incomeStructure.exportIncomeItems.${OTHER_INCOME_STRUCTURE_ID.OTHER_EXPORT_INCOME}`
    );
    unregister(
      `incomeStructure.exportIncomePercentages.${OTHER_INCOME_STRUCTURE_ID.OTHER_EXPORT_INCOME}`
    );

    yearFields.map((yearField) => {
      const internationalValue = exportIncomeItems[
        EXPORT_INCOME_TYPE_ID.INTERNATIONAL
      ][yearField] as string;
      const extendedValues = sumExtendedValues(
        exportIncomeItems,
        INCOME_SUBGROUP_CATEGORY.EXPORT_INCOME,
        yearField
      );

      if (internationalValue && extendedValues) {
        setValue(
          `incomeStructure.exportIncomeItems.${OTHER_INCOME_STRUCTURE_ID.OTHER_EXPORT_INCOME}.${yearField}`,
          calcNetIncomeItem(internationalValue, extendedValues)
        );
      }
    });

    close();
  };

  return (
    <>
      <IconButton
        color="inherit"
        size="small"
        sx={{ padding: 0 }}
        onClick={open}
        disabled={isCompletedTh || isCompletedEn}
      >
        <DeleteOutlineIcon style={{ fontSize: '14px' }} />
      </IconButton>
      <DeleteModal
        topic={`ประเทศ${countryNameTh}`}
        opened={opened}
        close={close}
        confirm={handleDelete}
      />
    </>
  );
};

export default ExportIncomeDeleteButton;
